/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { StateSanitizer } from '@ngrx/store-devtools/src/config';
import { IPlaceCategory, IReverseGeocodeResponse, LatLng } from '../../core/models';
import { GoogleMapsShape } from '../../maps/models';
import { EGeofenceDrawingControlShape, IPlace } from '../models';

export interface IGeofenceState {
  geofenceLatLng: LatLng | null;
  geofenceAddress: IReverseGeocodeResponse | null;
  geofenceCreateOpen: boolean;
  drawingControlShape: EGeofenceDrawingControlShape;
  drawingControlClearPressed: Date | null;
  currentShape: GoogleMapsShape | null;
  placeDropdownCategories: IPlaceCategory[];
  placeLoaded: IPlace;
}

export const initialGeofenceState: IGeofenceState = {
  geofenceLatLng: null,
  geofenceAddress: null,
  geofenceCreateOpen: false,
  drawingControlShape: EGeofenceDrawingControlShape.Circle,
  drawingControlClearPressed: null,
  currentShape: null,
  placeDropdownCategories: [],
  placeLoaded: null
};

// A dev tool sanitizer is needed as we are storing large google maps objects which
// can't be serialized
export const geofenceStateDevToolSanitizer: StateSanitizer = (state: any) => {
  if (!state.geofence?.currentShape) {
    return state;
  }

  const type =
    state.geofence.currentShape instanceof google.maps.Circle
      ? 'Circle'
      : state.geofence.currentShape instanceof google.maps.Rectangle
      ? 'Rectangle'
      : 'Polygon';

  return state.geofence?.currentShape
    ? { ...state, geofence: { ...state.geofence, currentShape: `Google Maps ${type} Object (This is just a display value for dev tools)` } }
    : state;
};
